import { createWithEqualityFn } from 'zustand/traditional';
import { api } from '@weareconceptstudio/core';

const createInitialState = () => ({
	globalData: {},
	prevRoute: null,
	preloader: true,
	firstLoad: true,
	loading: false,
	lang: null,
});

export const useDataStore = createWithEqualityFn((set, get) => ({
	...createInitialState(),

	setInitialData: ({ newData, lang }) => {
		const globalByLang = newData?.globalData || {};
		const langData = globalByLang[lang];

		set((state) => ({
			...state,
			...newData,
			globalData: langData && typeof langData === 'object' ? langData : {},
			lang,
		}));
	},

	setPrevRoute: (prevRoute) => set({ prevRoute }),

	setFirstLoad: () => set({ firstLoad: false }),

	enableLoading: () => set({ loading: true }),
	disableLoading: () => set({ loading: false }),

	disablePreloader: () => set({ preloader: false }),

	contactUs: (data) => api.post('contact-us', data),
}));

